import { Component, OnInit, Input } from '@angular/core';
import { ApiOffer, ApiOfferSet } from '@tytapp/api';
import { UserService } from '@tytapp/user';
import { SubSink } from 'subsink';

@Component({
  selector: 'tyt-fixed-price-offer',
  templateUrl: './fixed-price-offer.component.html',
  styleUrls: ['./fixed-price-offer.component.scss']
})
export class FixedPriceOfferComponent implements OnInit {
  constructor(
    private userService : UserService
  ) { }

  nextStep = 'signup';

  @Input()
  offer: ApiOffer;

  @Input()
  offerSet: ApiOfferSet;

  subsink = new SubSink();

  period: string;

  ngOnInit() {
    this.subsink.add(this.userService.userChanged.subscribe(user => {
      this.nextStep = user ? 'payment' : 'signup';
    }));

    if(this.offer && this.offer.period) {
      if(this.offer.period === 'monthly') {
        this.period = '/month';
      } else if (this.offer.period === 'annually') {
        this.period = '/year';
      }
    }
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
